import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { ThemMoiTaiSanCongTy } from "components/CommonComponent/ThemMoiTaiSanCongTy";

export const BtnSua = ({ TaiSanID,onSearch }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <a onClick={handleShow} href={() => false}>
        <PopoversBootrap
          contentText="Sửa"
          titleText=""
          trigger={["hover", "focus"]}
          placement={"top"}
        >
          <img src="/app-assets/images/icon-sua-v3.png" />
        </PopoversBootrap>
      </a>
      {show && (
        <ThemMoiTaiSanCongTy
          show={show}
          onHide={handleClose}
          TaiSanID={TaiSanID}
          onSearch={onSearch}
        />
      )}
    </>
  );
};
